 
import {QuestionType} from '../enums/QuestionType';

export class Answer {
    
    public answerIds: Array<string>;
    public questionId: string;
    public isChecked?: boolean;
    public questionType: QuestionType;
    public text: string;
    public required: boolean;
    constructor(init?:Partial<Answer>) {
        
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./models/Answer.ts